import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=22e0af1e&scoped=true&"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=22e0af1e&prod&lang=scss&scoped=true&"
import style1 from "./PurchaseOrderDetail.vue?vue&type=style&index=1&id=22e0af1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0af1e",
  null
  
)

export default component.exports